import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../../collection'
import type { Feature } from '../feature'

/** Reloads the selected source after a document is deleted. */
export const handleDeleteSuccess = store.effects.create(
  (_: Feature, collection: Collection) =>
    collection.fileOperations.actions.delete.success
      .observe()
      .pipe(
        rxjs.map(action =>
          collection.plugins.currentListPlugin.feature.actions.load
            .from(action)
            .create(),
        ),
      ),
)
